export default __webpack_public_path__ + "static/media/fromTheFrugalToTheOrnateTabBanner.fe4438a2.png";